import { call, put, takeLatest } from 'redux-saga/effects';

import { getAppIsReadyCheck } from '../../../services/API';
import { actionTypes, requestFailure, requestSuccess } from './actions';

function* getData() {
  const response = yield call(getAppIsReadyCheck);
  yield put(response.isOk ? requestSuccess(response.data) : requestFailure(response.error));
}

export default function* appIsReadyCheckSaga() {
  yield takeLatest(actionTypes.REQUEST_START, getData);
}
